export const DAY_IN_HOURS = 24;
export const WEEK_IN_DAYS = 7;
export const MONTH_IN_DAYS = 30;
export const YEAR_IN_DAYS = 365;

export const HOUR_IN_SECONDS = 60 * 60;
export const DAY_IN_SECONDS = DAY_IN_HOURS * HOUR_IN_SECONDS;
export const WEEK_IN_SECONDS = WEEK_IN_DAYS * DAY_IN_SECONDS;
export const MONTH_IN_SECONDS = MONTH_IN_DAYS * DAY_IN_SECONDS;
export const YEAR_IN_SECONDS = YEAR_IN_DAYS * DAY_IN_SECONDS;
